module.exports = __webpack_public_path__ + "assets/images/route-planning@3x-3846e3ee1e64e864833f82c128308981.png";